/** Preset swatches for the Salary Sheet row-highlight picker — light
 * backgrounds so black text stays readable. Shared by ManagementDailySalarySheet.tsx
 * and SalarySheet.tsx (nurse/physio) so a highlighted row looks the same
 * regardless of which sheet it's on. */
export const ROW_HIGHLIGHT_COLORS = [
  { label: 'Red',    value: '#fecaca' },
  { label: 'Orange', value: '#fed7aa' },
  { label: 'Yellow', value: '#fef08a' },
  { label: 'Green',  value: '#bbf7d0' },
  { label: 'Blue',   value: '#bfdbfe' },
  { label: 'Purple', value: '#e9d5ff' },
];

/** Preset swatches for the Remarks text-color picker — darker/saturated so
 * they stay readable as font color (the light ROW_HIGHLIGHT_COLORS pastels
 * would be illegible as text). Same swatch positions/labels as
 * ROW_HIGHLIGHT_COLORS, just a darker shade of each. */
export const TEXT_HIGHLIGHT_COLORS = [
  { label: 'Red',    value: '#dc2626' },
  { label: 'Orange', value: '#ea580c' },
  { label: 'Yellow', value: '#ca8a04' },
  { label: 'Green',  value: '#16a34a' },
  { label: 'Blue',   value: '#2563eb' },
  { label: 'Purple', value: '#7c3aed' },
];
